export const getNonWorkingDaysOfMonth = (
  year: number,
  month: number,
  holidays: Array<string>
) => {
  const holidaysOfMonth = holidays.filter((holiday) => {
    const holidayDate = new Date(holiday);
    return (
      holidayDate.getMonth() === month && holidayDate.getFullYear() === year
    );
  });
  const holidaysDateArray = holidaysOfMonth.map((holiday) => new Date(holiday));
  return holidaysDateArray;
};

export const getNonWorkingDaysOfYear = (
  year: number,

  holidays: Array<string>
) => {
  const nonWorkingDays = [];

  for (let month = 0; month < 12; month++) {
    const monthNonWorkingDays = getNonWorkingDaysOfMonth(year, month, holidays);

    nonWorkingDays.push(...monthNonWorkingDays);
  }

  return nonWorkingDays;
};
